export enum InboundQueries {
  INBOUNDS = 'inbounds',
  INBOUND = 'inbound',
}

export const inboundsKeys = {
  all: () => [InboundQueries.INBOUNDS] as const,
  byId: (id: string) => [InboundQueries.INBOUND, id] as const,
}
